// extracted by mini-css-extract-plugin
export var drawerPaper = "_2g-0";
export var itemCard = "_2g-1";
export var itemImage = "_2g-2";